export class DisplayOptionsMode {
    static readonly NAME: number = 1;
    static readonly CODE: number = 2;
    static readonly NAME_CODE: number = 3;
}
